/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line turbo/no-undeclared-env-vars
export const customFetch = (uri, options) => {
  const { operationName } = JSON.parse(options.body);
  // eslint-disable-next-line turbo/no-undeclared-env-vars
  const _uri = process.env.API_URI || uri;
  // eslint-disable-next-line turbo/no-undeclared-env-vars

  var _customFetch = `${process.env.API_URL + _uri}?opname=${operationName}`;
  if (process?.env?.AUTH_API_URL && operationName === 'Auth') 
    _customFetch = `${process.env.AUTH_API_URL + _uri}?opname=${operationName}`;
  
  return fetch(_customFetch, options);
};

export const defaultTimeZone = { timeZone: 'Europe/Stockholm' };
export const defaultLocale = { locale: 'sv-SE' };
